import React, { useState, useEffect } from 'react';

import { useLocation, useHistory } from 'react-router-dom';

import { Tabs, Tab } from '../../../../components/Tabs';
import NiokrTab from '../../../../components/project/Widgets/Requests/NiokrTab';
import RidTab from '../../../../components/project/Widgets/Requests/RidTab';
import HintCard from '../../../../components/common/HintCard/HintCard';

const tabs = [
  {
    label: 'NIOKR',
    tabName: 'Заявки на НИОКР',
    content: NiokrTab,
  },
  {
    label: 'RID',
    tabName: 'Заявки на РИД',
    content: RidTab,
  },
];

export default function ProjectRequests({ projName }) {
  const history = useHistory();
  const location = useLocation();
  const [showCreate, setShowCreate] = useState(false);

  useEffect(() => {
    if (showCreate === true) history.push(`${location.pathname}?card`);
    else if (location.search.includes('card')) {
      history.goBack();
    }
  }, [showCreate, history, location.search, location.pathname]);

  useEffect(() => {
    if (!location.search.includes('card')) {
      setShowCreate(false);
    }
  }, [location.search]);

  return (
    <div style={{ color: 'black' }}>
      <HintCard
        cardStyles={{ fontSize: '18px', marginTop: 0, fontsize: '18px' }}
        noGutter
        rowStyles={{ padding: 0, margin: 'auto', marginBottom: '1em' }}
        text="Для добавления статей/доходов/заявок в проект, убедитесь, что заполнен реестр «Участники»"
      />
      <Tabs>
        {tabs.map((tab, i) => (
          <Tab key={i} label={tab.label} tabName={tab.tabName}>
            <tab.content projName={projName} showCreate={showCreate} setShowCreate={setShowCreate} />
          </Tab>
        ))}
      </Tabs>
    </div>
  );
}
